import { RESET_STATE } from 'services/auth/constants';
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
// @ts-ignore
import { SET_CURRENT_SEASON_ID } from 'services/currentSeasonId/constants';

// Local Constants
import keyBy from 'lodash.keyby';
import {
    SPRAY_EVENTS_SET,
    SPRAY_EVENTS_DELETE,
    SPRAY_EVENT_SET,
    SPRAY_EVENT_DELETE_SUCCEEDED
} from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import {
    SprayEventsState,
    SprayEventsActions,
    SprayEventStartingRow
} from './types';

const initialState = {};

export default function (
    state: SprayEventsState = initialState,
    action: SprayEventsActions | ResetStateAction
): SprayEventsState {
    switch (action.type) {
        case SPRAY_EVENTS_SET:
            return {
                ...state,
                ...action.payload
            };
        case SPRAY_EVENT_SET:
            return {
                ...state,
                [action.payload.uuid]: action.payload
            };
        case SPRAY_EVENTS_DELETE:
        case SPRAY_EVENT_DELETE_SUCCEEDED: {
            const { uuids } = action.payload;

            const copy = { ...state };

            uuids.map((uuid) => delete copy[uuid]);

            return copy;
        }
        case SET_CURRENT_ORGANIZATION_ID:
        case SET_CURRENT_SEASON_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
